import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const portfolioReducer = handleActions(
  {
    PORTFOLIOS_STATISTICS: {
      FULFILLED: (_, { payload: { statistics } }) => ({
        statistics,
      }),
    },

    PORTFOLIOS_GET: {
      FULFILLED: (_, { payload: { portfolios } }) => ({
        portfolios,
      }),
    },

    PORTFOLIOS_REQUEST_ACCESS: {
      FULFILLED: ({ portfolios }, { meta: { portfolioID } }) => ({
        portfolios: updateById(portfolios, {
          id: portfolioID,
          requestedAccess: true,
        }),
      }),
    },

    PORTFOLIO_SWITCH: (_, { payload: { portfolioIDs } }) => ({
      selectedPortfolioIDs: portfolioIDs,
    }),

    PORTFOLIO_SUBSCRIBE_FULFILLED: ({ portfolios }, { meta }) => ({
      portfolios: updateById(portfolios, {
        id: meta.portfolioID,
        subscribedToDealDigest: true,
      }),
    }),

    PORTFOLIO_UNSUBSCRIBE_FULFILLED: ({ portfolios }, { meta }) => ({
      portfolios: updateById(portfolios, {
        id: meta.portfolioID,
        subscribedToDealDigest: false,
      }),
    }),

    PORTFOLIO_POINT_PERSONS_GET: {
      PENDING: () => ({
        pointPersons: [],
      }),

      FULFILLED: (state, { payload: { pointPersons } }) => ({
        pointPersons,
      }),
    },

    PORTFOLIO_CREATE_FULFILLED: ({ portfolios }, { payload: { portfolio } }) => ({
      portfolios: [
        ...portfolios,
        {
          ...portfolio,
          limitations: [],
          totalAssets: 0,
          totalDeals: 0,
        },
      ],
    }),

    PORTFOLIO_UPDATE_FULFILLED: ({ portfolios }, { payload: { portfolio } }) => ({
      portfolios: updateById(portfolios, portfolio),
    }),

    PORTFOLIO_DELETE_FULFILLED: (
      { portfolios, selectedPortfolioIDs },
      { meta: { portfolioID } }
    ) => ({
      selectedPortfolioIDs: selectedPortfolioIDs.filter((s) => s !== portfolioID).length
        ? selectedPortfolioIDs.filter((s) => s !== portfolioID)
        : portfolios.filter((s) => s.id !== portfolioID)[0],
      portfolios: removeById(portfolios, portfolioID),
    }),

    PORTFOLIO_MODAL_OPEN: ({ portfolios }, { meta: { portfolioID } }) => ({
      isPortfolioModalOpen: true,
      portfolios: updateById(
        portfolios.map((p) => ({ ...p, isEdit: false })),
        { id: portfolioID, isEdit: true }
      ),
    }),

    PORTFOLIO_MODAL_CLOSE: ({ portfolios }) => ({
      isPortfolioModalOpen: false,
      portfolios: portfolios.map((p) => ({ ...p, isEdit: false })),
    }),

    PORTFOLIO_DELETE_MODAL_OPEN: () => ({
      isPortfolioDeleteModalOpen: true,
    }),

    PORTFOLIO_DELETE_MODAL_CLOSE: () => ({
      isPortfolioDeleteModalOpen: false,
    }),
  },
  {},
  { namespace: "_" }
);

export default portfolioReducer;
